import Home from "../pages/student/Home/Home"
import ListLetters from "../pages/student/ListLetter/ListLetter"
import RequestingLetter from "../pages/student/RequstingLetter/RequestingLetter"
import MyLetters from "pages/student/MyLetters/MyLetters"


const routes = [
    { path: '/', component: Home, exact: true }, 
    { path: '/daftar-surat', component: ListLetters, exact: true }, 
    { path: '/ajukan-surat/:id', component: RequestingLetter, exact: true },  
    { path: '/surat-saya', component: MyLetters, exact: true },  
]

export default routes